import script from "./GridCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridCard.vue?vue&type=script&lang=ts&setup=true"

import "./GridCard.vue?vue&type=style&index=0&id=041f3dfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041f3dfa"]])

export default __exports__